export const isNotEmpty = (value) => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).length > 0;
  }
  return false; // Not an array or object
};

export const isEmpty = (value) => {
  if (Array.isArray(value)) {
    return !(value.length > 0);
  }
  if (typeof value === 'object' && value !== null) {
    return !(Object.keys(value).length > 0)
  }
  return true; // Not an array or object
};

export const detectCardType = (number) => {
  // Remove all non-digit characters
  const cleaned = number.replace(/\D/g, '');

  // Visa cards start with 4 and are 16 digits long
  if (/^4/.test(cleaned)) {
    return 'visa';
  }
  // Mastercard numbers start with 51-55 or 2221-2720, 16 digits long
  else if (/^5[1-5]/.test(cleaned) || /^2[2-7]/.test(cleaned)) {
    return 'mastercard';
  }
  return null;
};

export const formatDate = (dateString) => {
  if (!dateString) return "";
  return dateString.substring(0, 10).replaceAll("-", "/");
};